import templateComponents from '../../../Template/theme/components'
import auto from './auto'
export default {
    ...templateComponents,
    auto,
}